module.exports = __webpack_public_path__ + "static/media/ft-marketing.f9a2932f.svg";